import { Toaster } from "react-hot-toast";

const GlobalToaster = () => {
  return (
    <Toaster
      position="top-center"
      limit={1}
      toastOptions={{
        duration: 3200,

        /* ───────── Base Luxury Surface ───────── */
        style: {
          background: "#FFF8E6", // surfaceColor
          color: "#1F2937", // primaryText
          borderRadius: "16px",
          padding: "14px 18px",
          scrollbarGutter: "stable",
          fontFamily: "Poppins, sans-serif",
          boxShadow: "0 12px 35px rgba(0, 0, 0, 0.18)",
          border: "1px solid rgba(212, 175, 55, 0.25)", // gold subtle border
        },

        /* ───────── Success ───────── */
        success: {
          iconTheme: {
            primary: "#16A34A", // success
            secondary: "#FFF8E6",
          },
          style: {
            background: "#F3FBF6",
            borderLeft: "5px solid #16A34A",
          },
        },

        /* ───────── Error ───────── */
        error: {
          iconTheme: {
            primary: "#DC2626", // danger
            secondary: "#FFF8E6",
          },
          style: {
            background: "#FEF2F2",
            borderLeft: "5px solid #DC2626",
          },
        },

        /* ───────── Loading (Gold Accent) ───────── */
        loading: {
          iconTheme: {
            primary: "#D4AF37", // primaryAccent
            secondary: "#FFF8E6",
          },
          style: {
            background: "#FFFBF0",
            borderLeft: "5px solid #D4AF37",
          },
        },
      }}
    />
  );
};

export default GlobalToaster;
